window.Yext = window.Yext || {};
import 'babel-polyfill';
import 'script-loader!node_modules/jquery/dist/jquery.min.js';

// uncomment if you need to do expand/collapse:
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
// import 'node_modules/bootstrap-sass/assets/javascripts/bootstrap/transition.js';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { InitSoy2JS } from 'js/components/Soy2js/Soy2js.js';
InitSoy2JS(window.Yext);

import { DistanceCalculator } from 'ts/components/DistanceCalculator/index.ts';
import { Sniffer } from 'ts/components/Sniffer/index.ts';

import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';

Global.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {

  // - The un-minified file is different than the minified one :/
  // - Uncomment the following if using JVector map
  // VectorMap.autorun();
});
